import Vue from 'vue'

const API_URL = '/api/auth';

export default {
    namespaced: true,
    getters: {
        isLoggedIn: (state) => !!state.token,
        authStatus: (state) => state.status
    },
    state: {
        status: '',
		token: localStorage.getItem('token')
    },
    mutations: {
		AUTH_SUCCESS(state, token) {
			state.status = 'success'
			state.token = token
		},
	
		REVOKED() {
			
		},
    },
    actions: {
		async login({commit}, form_data) {
			const resp = await Vue.prototype.$http.post(API_URL + '/login', form_data)
			if(resp.data.user == false)
			{
				return resp
			}
			const token = resp.data.token
			localStorage.setItem('token', token)
            localStorage.setItem('users', JSON.stringify(resp.data.user));
			commit('AUTH_SUCCESS', token)
			return resp
		},

		async logout({commit}) {
			const resp = await Vue.prototype.$http.get(API_URL + '/logout')
			localStorage.removeItem('token')
            localStorage.removeItem('users')
			commit('REVOKED')
			return resp
		}
    }
}